export const generateViewType = (submenuNames, GanttType) => {
  const keys = Object.keys(GanttType);
  return Object.keys(submenuNames).map((key, index) => ({
    label: submenuNames[key],
    value: GanttType[keys[index]],
  }));
};
